import { Category } from "../api/types";

export default function mapCategoryFromString(valueToMap: string): Category | undefined {
    for (const [entry, value] of Object.entries(Category)) {
        if (entry.toLowerCase() === valueToMap.toLowerCase())
            return value as Category;
    }

    return undefined;
  }